import { get, post, patch, httpDelete } from '../../utils/http';

export const fetchKioskDevices = ({ accountId }) => get(`/accounts/${accountId}/kiosk/devices`);

export const patchKioskDevice = ({ accountId, deviceId, active, paired, cameraEnabled, name, branchIds }) => {
  const body = {};
  if (active !== undefined) {
    body.active = active;
  }
  if (paired !== undefined) {
    body.paired = paired;
  }
  if (cameraEnabled !== undefined) {
    body.cameraEnabled = cameraEnabled;
  }
  if (name !== undefined) {
    body.name = name;
  }
  if (branchIds !== undefined) {
    body.branchIds = branchIds;
  }
  return patch(`/accounts/${accountId}/kiosk/devices/${deviceId}`, body);
};

export const deleteKioskDevice = ({ accountId, deviceId }) =>
  httpDelete(`/accounts/${accountId}/kiosk/devices/${deviceId}`);

export const createKioskPairingSession = ({ accountId }) => post(`/accounts/${accountId}/kiosk/pairing-sessions`, {});
